import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitStatus('success');
      return;
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('http://lcwb.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
        setErrorMsg(parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试');
      }
    } catch {
      setSubmitStatus('error');
      setErrorMsg('网络错误，请稍后重试');
    }
  };

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-1/4">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl"></i>
              </div>
              <span className="text-lg font-bold font-heading">桃桃漫画</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              桃桃漫画网是韩国漫画画免费画漫画大全，海量资源，让您尽情享受绘画与阅读的乐趣。
            </p>
          </div>

          <div className="lg:w-3/4 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-sm font-semibold mb-4 font-heading">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 cursor-pointer">品牌介绍</Link>
                <Link to="/about" className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 cursor-pointer">荣誉资质</Link>
                <Link to="/about" className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 cursor-pointer">商务合作</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 font-heading">用户协议</h4>
              <div className="flex flex-col gap-2">
                <a href="/terms" className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">用户协议</a>
                <a href="/privacy" className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">隐私政策</a>
                <a href="/copyright" className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">版权声明</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 font-heading">热门分类</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/romance" className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">浪漫爱情</Link>
                <Link to="/category/fantasy" className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">奇幻冒险</Link>
                <Link to="/category/action" className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">动作热血</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 font-heading">订阅更新</h4>
              <p className="text-foreground-400 text-sm mb-3">获取最新漫画更新通知</p>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="anti-spam-field"
                />
                <div className="flex gap-2">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入您的邮箱"
                    required
                    className="flex-1 bg-foreground-800 border border-foreground-700 rounded-lg px-3 py-2 text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors duration-200"
                  />
                  <button
                    type="submit"
                    className="bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg px-4 py-2 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    订阅
                  </button>
                </div>
                {submitStatus === 'success' && (
                  <p className="text-accent-400 text-xs mt-2">订阅成功！</p>
                )}
                {submitStatus === 'error' && (
                  <p className="text-primary-400 text-xs mt-2">{errorMsg}</p>
                )}
              </form>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="font-heading text-lg font-bold">&copy;</span>
            <span className="text-sm text-foreground-400">2026 桃桃漫画网 All rights reserved.</span>
          </div>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">
              <i className="ri-wechat-line w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">
              <i className="ri-links-line w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">
              <i className="ri-movie-line w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer">
              <i className="ri-tiktok-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>

        <div className="text-center mt-6">
          <p className="text-foreground-400 text-sm leading-relaxed font-heading">
            以漫画之名，连接每一颗热爱故事的心。探索、发现、沉浸——你的漫画世界，从这里开始。
          </p>
        </div>
      </div>
    </footer>
  );
}